import { render, staticRenderFns } from "./ArticleInfoCover.vue?vue&type=template&id=f776acba&scoped=true&"
import script from "./ArticleInfoCover.vue?vue&type=script&lang=ts&"
export * from "./ArticleInfoCover.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleInfoCover.vue?vue&type=style&index=0&id=f776acba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f776acba",
  null
  
)

export default component.exports